<template>
    <div class="container-fluid">
        <h1>Заявки</h1>

        <dx-data-grid ref="grid"
                      :hoverStateEnabled="true"
                      :data-source="leadsData"
                      :columns="columns"
                      :show-borders="true"
                      :allowColumnResizing="true"
                      :column-hiding-enabled="true"
        >
            <dx-header-filter :visible="true"/>
            <dx-export :enabled="true" file-name="Заявки"/>
            <DxEditing
                    :allow-deleting="true"
                    :use-icons="true"
            />
            <!--Шаблон колонки-->
            <div slot="nameCellTemplate" slot-scope="data">
                <router-link :to="{path: 'visit/report/' + domain.id, query: {userHash: data.data.user_hash}}">
                    <font-awesome-icon icon="eye"></font-awesome-icon>
                </router-link>
                {{ data.data.lead_name }}
            </div>
        </dx-data-grid>
    </div>
</template>

<script>
    import {DxDataGrid, DxExport, DxHeaderFilter, DxEditing} from 'devextreme-vue/data-grid';


    import axios from 'axios';
    import {mapState} from "vuex";
    import CustomStore from 'devextreme/data/custom_store';

    export default {
        name: "LeadIndex",
        data() {
            return {
                leadsData: new CustomStore({
                    key: 'id',
                    load: () => this.requestLeads(),
                    remove: (key) => this.deleteLead(key)
                }),
                columns: [
                    {
                        dataField: 'lead_ts',
                        caption: 'Дата заявки',
                    },
                    {
                        dataField: 'page_name',
                        caption: 'Страница',
                        hidingPriority: 2
                    }
                    ,
                    {
                        dataField: 'lead_source',
                        caption: 'Источник',
                        hidingPriority: 6
                    },
                    {
                        dataField: 'lead_name',
                        caption: 'Имя',
                        cellTemplate: 'nameCellTemplate'
                    },
                    {
                        dataField: 'lead_phone',
                        caption: 'Телефон',
                        hidingPriority: 3
                    },
                    {
                        dataField: 'lead_email',
                        caption: 'E-Mail',
                        hidingPriority: 5
                    },
                    {
                        dataField: 'lead_params',
                        caption: 'Дополнительно',
                        hidingPriority: 4
                    },


                ]
            }
        },
        computed: {
            ...mapState({
                domain: state => state.domains.selectedDomain,
                domainStatus: state => state.domains.status,
            }),
            dataGrid() {
                return this.$refs.grid.instance;
            }
        },
        methods: {
            requestLeads() {
                console.log("requestLeads");
                if (this.domainStatus === 'success' && !this.domain) {
                    this.$router.push('/domain');
                }
                if (!this.domain) return;
                return axios.get('/api/lead/index/' + this.domain.id)
                    .then(function (resp) {
                        return resp.data;
                    })
                    .catch(function () {
                        throw "Невозможно загрузить информацию о лидах";
                    });
            },
            deleteLead(id) {
                console.log("deleting lead:" + id);
                return axios.delete('/api/' + this.domain.id + '/lead/' + id + '/delete')
                    .then(function (resp) {
                        return resp.data;
                    })
                    .catch(function () {
                        throw "Невозможно загрузить информацию о лидах";
                    });
            }
        },
        watch: {
            domain() {
                this.dataGrid.refresh();
            }
        },
        components: {
            DxDataGrid, DxExport, DxHeaderFilter, DxEditing
        }
    }
</script>

<style scoped>

</style>